module.exports = __webpack_public_path__ + "files/68746b3bb6851d8ffae0782619c48a42.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/logoWhite.png
 ** module id = 814
 ** module chunks = 0
 **/